/* 🤖 this file was generated by svg-to-ts */
export const mgcIconTextCuteRe: {
  name: 'text-cute-re';
  data: string;
} = {
  name: 'text-cute-re',
  data: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M4.673 4.063a.94.94 0 0 0-.366.236.96.96 0 0 0-.001 1.401c.311.311.18.3 3.641.3H11v7.073c0 7.95-.026 7.294.306 7.627.18.179.458.3.694.3.402 0 .827-.312.939-.69.054-.18.061-1.06.061-7.257V6h3.053c3.466 0 3.329.011 3.644-.303.183-.183.303-.46.303-.697 0-.402-.312-.827-.69-.939-.301-.09-14.346-.087-14.637.002"/></svg>`
};
